const COlUMNS = [
  {
    title: '名称',
    dataIndex: 'examName',
    width: '222px',
    ellipsis: true,
    align: 'center',
    scopedSlots: { customRender: 'examName' }
  },
  {
    title: '测评范围',
    dataIndex: 'examTypeName',
    width: '102px',
    align: 'center',
    scopedSlots: { customRender: 'examTypeName' }
  },
  {
    title: '测评时间',
    dataIndex: 'examStartTime',
    width: '288px',
    align: 'center',
    scopedSlots: { customRender: 'examStartTime' }
  },
  {
    title: '年级',
    dataIndex: 'clazzLevelName',
    width: '102px',
    align: 'center',
    ellipsis: true,
    scopedSlots: { customRender: 'clazzLevelName' }
  },
  {
    title: '状态',
    width: '102px',
    dataIndex: 'statusName',
    align: 'center',
    scopedSlots: { customRender: 'statusName' }
  },
  {
    title: '操作',
    dataIndex: 'operation',
    width: '190px',
    align: 'center',
    scopedSlots: { customRender: 'operation' },
    fixed: 'right'
  }
]

const PUB_COlUMNS = [
  {
    title: '名称',
    dataIndex: 'examName',
    width: '222px',
    ellipsis: true,
    align: 'center',
    scopedSlots: { customRender: 'examName' }
  },
  {
    title: '测评范围',
    dataIndex: 'examTypeName',
    width: '102px',
    align: 'center',
    scopedSlots: { customRender: 'examTypeName' }
  },
  {
    title: '测评时间',
    dataIndex: 'examStartTime',
    width: '288px',
    align: 'center',
    scopedSlots: { customRender: 'examStartTime' }
  },
  {
    title: '年级',
    dataIndex: 'clazzLevelName',
    width: '102px',
    align: 'center',
    scopedSlots: { customRender: 'clazzLevelName' }
  },
  {
    title: '状态',
    width: '102px',
    dataIndex: 'statusName',
    align: 'center',
    scopedSlots: { customRender: 'statusName' }
  },
  {
    title: '操作',
    dataIndex: 'operation',
    width: '190px',
    align: 'center',
    scopedSlots: { customRender: 'operation' },
    fixed: 'right'
  }
]

const CLAZZ_PUB_COLUMNS = [
  {
    title: '名称',
    dataIndex: 'newExamName',
    width: '230px',
    ellipsis: true,
    align: 'center',
    scopedSlots: { customRender: 'newExamName' }
  },
  {
    title: '测评范围',
    dataIndex: 'examTypeName',
    width: '102px',
    align: 'center',
    scopedSlots: { customRender: 'examTypeName' }
  },
  {
    title: '测评时间',
    dataIndex: 'startAt',
    width: '300px',
    align: 'center',
    scopedSlots: { customRender: 'startAt' }
  },
  {
    title: '班级',
    dataIndex: 'clazzName',
    width: '145px',
    align: 'center',
    scopedSlots: { customRender: 'clazzName' }
  },
  // {
  //   title: '状态',
  //   width: '102px',
  //   dataIndex: 'status',
  //   align: 'center',
  //   scopedSlots: { customRender: 'status' }
  // },
  {
    title: '操作',
    dataIndex: 'operation',
    width: '190px',
    align: 'center',
    scopedSlots: { customRender: 'operation' },
    fixed: 'right'
  }
]

const PUBLISH_LIST = [
  { label: '未发布', value: 1 },
  { label: '已发布', value: 2 }
]

const RANGE = [
  { label: '省级', value: 1 },
  { label: '市级', value: 2 },
  { label: '区级', value: 3 },
  { label: '校级', value: 4 }
]

export { COlUMNS, PUBLISH_LIST, RANGE, PUB_COlUMNS, CLAZZ_PUB_COLUMNS }
